import { DialogV2, AritoIcon, AritoFormV2, BottomActionBarV2 } from '@/components/custom/erp';
import { searchSchema, TaxRateFormattedData, type SearchFormValues } from '../../schemas';
import { BasicInformationTab } from '../AddingTab';

type FormMode = 'add' | 'edit' | 'view';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: SearchFormValues) => Promise<void>;
  formMode: FormMode;
  initialData?: TaxRateFormattedData;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

export const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy
}: FormDialogProps) => {
  const handleSubmit = async (data: SearchFormValues) => {
    try {
      await onSubmit?.(data);
    } catch (error) {
      console.error('Error submitting form:', error);
      // Keep the form open if there's an error
      return;
    }
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={`${formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục thuế suất'}`}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2<SearchFormValues>
          mode={formMode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={initialData as Partial<SearchFormValues>}
          className='w-[800px]'
          headerFields={
            <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
              <BasicInformationTab formMode={formMode} />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onSubmit={() => {}}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>
    </>
  );
};
